import {connect, Dispatch} from '@modifi/redux'
import {aShowDialog, DialogManager} from '@modifi/plugin-dialogs'

import DeleteSellerBankAccountDialog, {DELETE_SELLER_BANK_DIALOG_NAME} from './dialogs'

import DeleteSellerBankAccountButton from './DeleteSellerBankAccountButton'
import {aDeleteSellerBankAccount} from './store'

DialogManager.addDialog(DELETE_SELLER_BANK_DIALOG_NAME, DeleteSellerBankAccountDialog)

const mapStateToProps = null

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: {externalBankAccountId: string; target: string}
): {onClick: () => void} => ({
  onClick: (): void => {
    const onConfirm = async (): Promise<void> => {
      await dispatch(aDeleteSellerBankAccount(ownProps.externalBankAccountId) as any)
    }

    dispatch(
      aShowDialog(DELETE_SELLER_BANK_DIALOG_NAME, {
        onConfirm,
        target: ownProps.target,
      })
    )
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSellerBankAccountButton)
